export default __webpack_public_path__ + "static/media/Fotoentera.e6d29a1c.jpeg";